export default "__VITE_ASSET__hIIaJk8Y__"